export const SET_APP_LOCALE = "SET_APP_LOCALE";
export const SET_APP_BACKGROUND_COLOR = "SET_APP_BACKGROUND_COLOR";
export const SET_TOP_BAR_TEXT = "SET_TOP_BAR_TEXT";
export const SET_TOP_BAR_VISIBILITY = "SET_TOP_BAR_VISIBILITY";
export const SET_BOTTOM_NAV_BAR_VISIBILITY = "SET_BOTTOM_NAV_BAR_VISIBILITY";
export const SET_USER = "SET_USER";
export const SIGN_OUT = "SIGN_OUT";

export const GET_FULLSCREEN_LOADER_VISIBILITY = "GET_FULLSCREEN_LOADER_VISIBILITY";
export const GET_FULLSCREEN_TEXT = "GET_FULLSCREEN_TEXT";
